import script from "./TheProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./TheProduct.vue?vue&type=script&setup=true&lang=js"

import "./TheProduct.vue?vue&type=style&index=0&id=252aecbf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252aecbf"]])

export default __exports__